import { createRef, useEffect, useState } from 'react';
import './Masonry.style.scss';

export const Masonry = ({ children }: { children?: React.ReactNode }) => {
  const divRef = createRef<HTMLDivElement>();
  const [masonryClass, setMasonryClass] = useState('');

  useEffect(() => {
    if (divRef.current) {
      const { current } = divRef;
      const boundingRect = current.getBoundingClientRect();
      const { width } = boundingRect;
      if (width < 450) {
        setMasonryClass('masonry-small');
      } else if (width < 500) {
        setMasonryClass('masonry-medium');
      } else {
        setMasonryClass('masonry-large');
      }
    }
  }, [divRef]);

  return (
    <div ref={divRef} className={`masonry ${masonryClass}`}>
      {children}
    </div>
  );
};
